import styled from 'styled-components';
import ProductRow from 'src/components/product-row';

export const Header = styled.div`
  padding: 5px 10px;
`;

export const Product = styled(ProductRow)`
  align-items: start;
  min-height: auto;
`;
